import clsx from 'clsx';

export type DeviceStatus = 'ok' | 'warn' | 'fault' | 'idle' | 'offline';

const COLOR: Record<DeviceStatus, string> = {
  ok: 'bg-[color:var(--color-success)]',
  warn: 'bg-[color:var(--color-warning)]',
  fault: 'bg-[color:var(--color-danger)]',
  idle: 'bg-[color:var(--color-idle)]',
  offline: 'bg-transparent border-2 border-dashed border-[color:var(--color-offline)]',
};

export type StatusDotProps = {
  status: DeviceStatus;
  /** Diameter utility, default size-2.5 */
  className?: string;
  /** Pulse animation for live/attention states */
  pulse?: boolean;
};

export function StatusDot({ status, className, pulse = false }: StatusDotProps) {
  return (
    <span
      role="status"
      aria-label={status}
      className={clsx(
        'inline-block size-2.5 rounded-full',
        COLOR[status],
        pulse && status !== 'offline' && 'animate-pulse',
        className,
      )}
    />
  );
}
